import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {debounce} from "../../../helper/Debounce";
import SearchInput from "../../../components/Common/SearchInput";
import PaginationButtons from "../../../components/Common/Pagination";
import TableInfoBar from "../../../components/Admin/TableInfoBar";
import { MidjourneyLog } from "../../../interfaces/midjourney.interface";
import { fetchMidJourneyStats, searchMidJourneyStats } from "./services/MidJourneyStats.service";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import MidJourneyStatsTable from "./components/MidJorneyStatsTable";
import { TokenCookieManager } from "../../../utils/tokenCookies";

const MidJourneyStats = () => {
    const [loader, setLoader] = useState(true);
    const [MidJourneyStats, setMidJourneyStats] = useState<MidjourneyLog[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchLoading, setSearchLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState<number | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!TokenCookieManager.hasToken()) {
            navigate("/admin");
        }
    });
    const handlePageChange = (page: number | any) => {
        if (page > 0 && page <= totalPages!) setCurrentPage(+page);
    };

    const handleFetchMidJourneyStats = async () => {
        try {
            setLoader(true);
            const { stats, totalPages } = await fetchMidJourneyStats(currentPage);
            setMidJourneyStats(stats);
            setTotalPages(totalPages);
        } finally {
            setLoader(false);
        }
    };

    const handleSearchMidJourneyStats = async () => {
        try {
            setSearchLoading(true);
            const stats = await searchMidJourneyStats(searchTerm);
            setMidJourneyStats(stats);
        } finally {
            setSearchLoading(false);
        }
    };

    useEffect(() => {
        handleFetchMidJourneyStats();
    }, []);

    useEffect(() => {
        handleFetchMidJourneyStats();
    }, [currentPage]);

    const debouncedSearch = debounce(handleSearchMidJourneyStats, 300);

    useEffect(() => {
        if (searchTerm.length >= 3) {
            debouncedSearch();
        }
    }, [searchTerm]);

    return (
        <div className="p-0 md:p-4">
            {loader ? (
                <LoadingSpinner/>
            ) : (
                <>
                    <div className="float-left md:float-right mb-2 ">
                        <SearchInput placeholder={"Search Error"} onChange={(e) => setSearchTerm(e.target.value)}/>
                    </div>

                    {searchLoading ? (
                        <LoadingSpinner/>
                    ) : (
                        <>
                            <MidJourneyStatsTable MidJourneyStats={MidJourneyStats} />
                            <div className="flex justify-between items-center mt-4">
                                <TableInfoBar
                                    currentPage={currentPage}
                                    pageSize={25}
                                    totalPages={totalPages || 0}
                                    recordsOnPage={MidJourneyStats?.length || 0}
                                />
                                {(totalPages ?? 0) > 1 && (
                                    <PaginationButtons
                                        totalPages={totalPages!}
                                        currentPage={currentPage}
                                        handlePageChange={handlePageChange}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default MidJourneyStats;
